import algoliasearch from 'algoliasearch/lite';
import React from 'react';
import qs from 'qs';
import { useLocation, useNavigate } from 'react-router-dom';
import {
  InstantSearch,
  Hits,
  SearchBox,
  Pagination,
  Configure,
  connectHierarchicalMenu,
  connectRefinementList,
  ClearRefinements
} from 'react-instantsearch-dom';

import SearchResult from './Components/SearchResult';

const searchClient = algoliasearch(
  'TVH64D3HXT',
  'e6f9cda7fd64890e5ce8a4c1b54e36a6'
);

const DEBOUNCE_TIME = 200;

const createURL = (state) => `?${qs.stringify(state)}`;

const searchStateToUrl = (location, searchState) =>
  searchState ? `${location.pathname}${createURL(searchState)}` : '';

const urlToSearchState = (location) => qs.parse(location.search.slice(1));

const HierarchicalMenu = ({ items, refine, createURL }) => (
  <ul>
    {items.map(item => (
      <li key={item.label}>
        <a
          href={createURL(item.value)}
          style={{ fontWeight: item.isRefined ? '600' : '' }}
          onClick={event => {
            event.preventDefault();
            refine(item.value);
          }}
        >
          {item.label}
          <div className="ais-RefinementList-Count">({item.count})</div>
        </a>
        {item.items && (
          <HierarchicalMenu
            items={item.items}
            refine={refine}
            createURL={createURL}
          />
        )}
      </li>
    ))}
  </ul>
);

const CustomHierarchicalMenu = connectHierarchicalMenu(HierarchicalMenu);

function RefinementList({ items, refine }) {
  if (items.length === 0) {
    return null;
  }

  return (
    <div className="ais-RefinementList">
      <ul>
        {items.map(item => (
          <li
            key={item.label}
            className={[
              'ais-RefinementList-item',
              item.isRefined && 'ais-RefinementList-item--selected',
            ]
              .filter(Boolean)
              .join(' ')}
          >
            <label className="ais-RefinementList-label">
              <input
                className="ais-RefinementList-checkbox"
                type="checkbox"
                value={item.value}
                checked={item.isRefined}
                onChange={() => refine(item.value)}
              />
              {item.label}
              <div className="ais-RefinementList-Count">({item.count})</div>
            </label>
          </li>
        ))}
      </ul>
    </div>
  );
}

const CustomRefinementList = connectRefinementList(RefinementList);

const Webshop = () => {

  // Set indexName based on hostname.
  // @todo get variable from docker.
  let indexName = 'products_test';
  if (window.location.hostname.includes('lambo.nl')) {
    indexName = 'products_production';
  }

  const location = useLocation();
  const navigate = useNavigate();
  const [showFiltersMobile, setShowFiltersMobile] = React.useState(false);
  const [searchState, setSearchState] = React.useState(
    urlToSearchState(location)
  );
  const setStateId = React.useRef();

  React.useEffect(() => {
    const nextSearchState = urlToSearchState(location);

    if (JSON.stringify(searchState) !== JSON.stringify(nextSearchState)) {
      setSearchState(nextSearchState);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location]);

  function onSearchStateChange(nextSearchState) {
    clearTimeout(setStateId.current);

    setStateId.current = setTimeout(() => {
      navigate(
        searchStateToUrl(location, nextSearchState),
        nextSearchState
      );
    }, DEBOUNCE_TIME);

    setSearchState(nextSearchState);
  }

  const toggleFilterVisibility = () => {
    setShowFiltersMobile(!showFiltersMobile);
  };

  return (
    <div>
      <InstantSearch
        indexName={indexName}
        searchClient={searchClient}
        searchState={searchState}
        onSearchStateChange={onSearchStateChange}
        createURL={createURL}
      >
        <SearchBox
          translations={{
            placeholder: 'Doorzoek ons aanbod...',
          }}
          submit={<img src=""/>}
        />

        Zie ook: <a href="/bulk-bestellen">bulk bestellen</a>
        <div className="ais-InstantSearch">
          <div className="toggle-search-filter">
            <a href="#" onClick={toggleFilterVisibility} style={{cursor: 'pointer'}}>{showFiltersMobile ? "Verberg filters" : "Toon filters"}</a>
          </div>
          <div className={showFiltersMobile ? 'left-panel' : 'left-panel filters-mobile-collapsed'}>

            <ClearRefinements
              translations={{
                reset: 'Reset filters',
              }}
            />

            <div className="courses_filter">
              <h4>Vak</h4>
              <CustomHierarchicalMenu
                attributes={[
                  'field_courses_processed.lvl0',
                  'field_courses_processed.lvl1',
                ]}
              />
            </div>

            <h4>Doelgroep</h4>
            <CustomRefinementList attribute="field_audience" />

            <h4>Niveau</h4>
            <CustomRefinementList attribute="field_level" />

            <h4>Producttype</h4>
            <CustomRefinementList attribute="entity_bundle_processed" />

            <Configure hitsPerPage={12} />
          </div>

          <div className={'right-panel'}>
            <Hits hitComponent={SearchResult} />
            <Pagination />
          </div>

        </div>
      </InstantSearch>
    </div>
  );
}

export default Webshop;
